import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import { CheckCircleFilled, DownloadOutlined, FileZipOutlined } from "@ant-design/icons";
import { downloadAuthenticatedFile } from "../utils/downloadFile";
import "./ConversionSuccessModal.css";

const ConversionSuccessModal = ({
  open,
  onClose,
  fileName,
  downloadUrl,
  outputType = "pdf",
  requiresAuth = false,
  title = "Conversion Successful!",
  subtitle = "Your file has been converted successfully.",
  fileTypeLabel,
  fileTypeIcon,
}) => {
  const [downloading, setDownloading] = useState(false);
  const isZip = outputType === "zip";
  const typeLabel = fileTypeLabel || (isZip ? "ZIP" : "PDF");
  const typeIcon = fileTypeIcon || (isZip ? <FileZipOutlined /> : <DownloadOutlined />);

  const handleDownload = async () => {
    if (!downloadUrl) {
      return;
    }

    setDownloading(true);
    try {
      await downloadAuthenticatedFile(downloadUrl, {
        token: requiresAuth ? localStorage.getItem("token") || "" : "",
        fileName: fileName || (isZip ? "converted-files.zip" : "converted-file.pdf"),
      });
    } catch {
      message.error(`Unable to download ${typeLabel}. Please try again.`);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={440}
      centered
      className="conversion-success-modal"
    >
      <div className="csm-body">
        <CheckCircleFilled className="csm-icon" />
        <div className="csm-title">{title}</div>
        <p className="csm-sub">{subtitle}</p>

        <div className="csm-actions">
          <Button
            type="primary"
            size="large"
            icon={typeIcon}
            onClick={handleDownload}
            loading={downloading}
            className="csm-download-btn"
          >
            Download {typeLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConversionSuccessModal;
